import {createSelector} from 'reselect';

// Stocks redux state
const stocksReducerSelector = state => state.stocks;

// Stocks List
const stocksSelector = createSelector(
    stocksReducerSelector,
    stocksReducer => stocksReducer.get('payload')
);

// Stocks is fetching
const stocksIsFetchingSelector = createSelector(
    stocksReducerSelector,
    stocksReducer => stocksReducer.get('isFetching')
);

// Stocks error
const stocksErrorSelector = createSelector(
    stocksReducerSelector,
    stocksReducer => stocksReducer.get('error')
);

export {
    stocksSelector,
    stocksIsFetchingSelector,
    stocksErrorSelector
};